import { CelSideItemInterface } from '@savvaslearning/cel-components/dist-stencil/interfaces/components/cel-side-navigation/cel-side-item-interface';
import {
  CachedStudentReportData,
  ForecastProbability,
  ForecastTextSegments,
  FrameworkType,
  MetricMeasureData,
  StudentReportPayload,
} from '../../shared/models/common.model';

export enum GROWTH_REPORT_PATHS {
  OVERALL_SCORE_SUMMARY = 'overall-score-summary',
  DOMAIN_SUMMARY = 'domain-summary',
  STUDENT_REPORT = 'student-report',
}

export enum GROWTH_REPORT_CHILD_PATHS {
  SCALE_SCORE = 'scale-score',
  METRIC = 'metric',
}

export interface NavigationTabs extends CelSideItemInterface {
  path: `${GROWTH_REPORT_PATHS}`;
}

export enum AssessmentReportingType {
  BOY = 'BOY',
  EOY = 'EOY',
  MOY = 'MOY',
}

export enum DomainKey {
  OV = 'OV',
}

export enum Domains {
  OV = 'Overall Score',
}

export enum NoScoreDash {
  DASH = '—',
}

export interface ClassAverage {
  scaleScore: number;
  noOfStudents: number;
}

export interface PercentileRange {
  percentileLow: number;
  percentileHigh: number;
}

export interface StudentsGrowthPerDomain {
  reportingTypes: AssessmentReportingType[];
  growth: Map<string, DomainPlacementLevelData>;
}

export interface DomainPlacementLevelData {
  noOfStudents: number;
}

export interface ForecastTranslationParams {
  firstName: string;
  reportType: AssessmentReportingType;
  forecastLevel: ForecastProbability;
  forecastTestNameAcronym: string;
}

export interface PopupMenuItem {
  id: string;
  label: string;
}

export interface StudentScaleScorePrintData {
  studentId: string;
  studentName: string;
  reportingType: AssessmentReportingType;
  studentReport: StudentReportPayload;
}

export interface MappedStudentReportData extends CachedStudentReportData {
  overallScaledScore: number;
  nationalPercentile: number;
  firstName: string;
}

export interface StudentMetricPrintData extends StudentScaleScorePrintData {
  metricMeasureData: MetricMeasureData;
  frameworkType: FrameworkType;
  showForecastingCard: boolean;
  forecastProbabilities: ForecastProbability[];
  highestPercentileProbability: ForecastProbability;
  forecastDynamicText: ForecastTextSegments;
  showZeroStateCard: boolean;
  forecastReportTitle: string;
  likelihoodLabel: string;
  assessmentWindowEndedMessage: string;
}
